import styled from 'styled-components';
import { media } from '@carvana/stc-styles';

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.carvana.white.primary};
`;

const Content = styled.div`
  margin: 0 auto;
  padding: 50px 0;
  width: 327px;

  ${media.sm`
    width: 704px;
    padding: 60px 0;
  `}
`;

const BodyText = styled.p`
  color: ${({ theme }) => theme.carvana.gray.dark};
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px;

  ${media.md`
    width: 630px;
    margin-left: 30px;
  `}
`;

const Title = styled.p`
  color: ${({ theme }) => theme.carvana.blue.dark};
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;

  ${media.sm`
    text-align: center;
  `}
`;

export { Container, Content, Title, BodyText };
